/**
 * Adresele din markupul desenat de server, aduse la o forma care merge de
 * oriunde din aplicatie.
 *
 * -----------------------------------------------------------------------------
 * CE ERA GRESIT
 * -----------------------------------------------------------------------------
 *
 * `application/Services/Dashboard/Draw.php` scrie legaturile RELATIV:
 * `inventoree/live_agentbased`, fara bara la inceput. Pe `/app/dashboard` asta
 * se rezolva din intamplare bine - browserul le lipeste de `/app/`. Pe
 * `/app/dashboard/board/12` se lipesc de `/app/dashboard/board/`, si ies adrese
 * care nu duc nicaieri.
 *
 * Fisierul acela e IMPARTIT cu portalul vechi: acolo aceleasi siruri se
 * rezolva corect, fiindca tabloul vechi sta chiar pe `/dashboard`. O corectura
 * in el ar misca si productia, pentru o problema pe care productia n-o are.
 *
 * Asa ca se repara aici, la citire: markupul vine ca text, si adresele din el
 * se aseaza inainte sa ajunga in pagina. Portalul vechi ramane neatins.
 *
 * -----------------------------------------------------------------------------
 * CARE UNDE MERGE
 * -----------------------------------------------------------------------------
 *
 * O adresa care arata catre o pagina MUTATA in v4 trebuie sa ramana in
 * aplicatie, sub `/app/`. Una catre o pagina care n-a fost mutata trebuie sa
 * iasa in portalul vechi, cu bara la inceput. Lista celor mutate e aceeasi pe
 * care o citesc si redirectarile - vezi `movedPages` - ca sa nu se desparta.
 */

import { hrefOf } from '../overview/href'

/** Adresele deja bune: absolute, cu schema, sau ancore. */
function leaveAlone(url: string): boolean {
  return (
    url === ''
    || url.startsWith('/')
    || url.startsWith('#')
    || url.startsWith('http://')
    || url.startsWith('https://')
    || url.startsWith('mailto:')
    || url.startsWith('javascript:')
  )
}

/**
 * O singura adresa, asezata.
 *
 * @param url ce a scris serverul, de obicei `modul/pagina`
 */
export function placeUrl(url: string): string {
  if (leaveAlone(url)) {
    return url
  }

  /* Partea dinaintea semnului de intrebare e ce se compara cu lista: o pagina
     mutata ramane mutata si cu parametri dupa ea. Coada se lipeste la loc. */
  const [path, ...rest] = url.split('?')
  const tail = rest.length > 0 ? '?' + rest.join('?') : ''

  const placed = hrefOf(path)

  /*
   * `hrefOf` intoarce null pentru adresele moarte in amandoua portalurile.
   * Aici se lasa asa cum au venit: cardul e desenat de server, iar o legatura
   * scoasa din markup ar lasa un text care arata a link si nu face nimic.
   * Moartele se repara la sursa, unde se si vede care sunt.
   */
  return placed === null ? url : placed + tail
}

/**
 * Markupul unui card, cu toate adresele din el asezate.
 *
 * Se lucreaza pe text, nu pe DOM: markupul intra oricum prin
 * `dangerouslySetInnerHTML`, iar o trecere prin DOM doar ca sa fie scoasa
 * inapoi ar fi mai mult de lucru pentru acelasi rezultat.
 *
 * @param html ce a desenat serverul
 */
export function placeLinks(html: string): string {
  return html.replace(/href="([^"]*)"/g, (whole, url: string) => {
    const placed = placeUrl(url)

    return placed === url ? whole : `href="${placed}"`
  })
}
